<template>
  <div>
    <div class="parent-box">
      <h3 class="red-h3">
        注销后，账号所有相关信息及资产，都会被清空
        且无法找回，具体包括但不限于：
      </h3>

      <ul>
        <li>个人资料、会员等级、权益及预约、收藏、发布内容等信息。</li>

        <li>账号的余额、订单、卡券、积分和活动福利等。</li>
      </ul>

      <h3 id="mid-h3">
        为保证您的账号、财产安全，在提交注销前请确认您的账号是否满足以下条件：
      </h3>

      <ul>
        <li>
          账号没有被盗，被封等风险；最近7天内无密码找回、修改密码等操作。
        </li>
        <li>
          账号没有其他未完成或欠款、存在争议的订单或服务。例如小号交易等。
        </li>
      </ul>

      <!-- <van-radio-group id="check-box" v-model="checked">
           <van-radio name="0" shape="square"></van-radio>
        </van-radio-group> -->

      <van-checkbox
        id="check-box"
        v-model="checked"
        checked-color="#12CEC7"
        shape="square"
        >我已阅读并同意注销声明</van-checkbox
      >

      <van-button
        id="btn-submit"
        round
        block
        type="primary"
        :disabled="btnEnable"
        color="#12CEC7"
        @click="onNext"
      >
        继续注销
      </van-button>
    </div>
  </div>
</template>

<script>
import { reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { getQueryString } from "@/utils/location";
export default {
  name: "newspage",
  setup() {
    const checked = ref(false);
    const btnEnable = ref(true);
    const router = useRouter();
    const state = reactive({
         
    });

    watch(checked, (newChecked) => {
      // 通过复选框判断按钮禁用
      if (newChecked) {
        btnEnable.value = false;
      } else {
        btnEnable.value = true;
      }
    });

    const onNext = () => {
      router.push({
        path: "/newAccountCancel/AccountCancelVeritify",
        query: {
          username: getQueryString("username"),
          uid:getQueryString("uid"),
        },
      });
    };

    return {
      checked,
      state,
      onNext,
      btnEnable,
    };
  },
};
</script>

<style scoped="scoped">
.parent-box {
  padding: 30px;
  background-color: #f7f8fa;
  min-height: 100vh;
}

.red-h3 {
  font-size: 32px;
  font-family: 苹方-简-中粗体, 苹方-简;
  font-weight: normal;
  color: #ff3939;
}

.parent-box ul {
  margin-top: 28px;
  margin-left: 30px;
}

.parent-box ul li {
  list-style: disc !important;
  font-weight: normal;
  color: #333;
  font-size: 28px;
}

#mid-h3 {
  margin-top: 56px;
  color: #333;
}

#check-box {
  margin-top: 80px;
}

.parent-box:deep(.van-checkbox__label) {
  color: #12CEC7;
}

#btn-submit {
  margin-top: 60px;
}

/* .parent-box:deep() */
</style>
